import React from "react";
import { QRCodeSVG } from "qrcode.react";

export default function TicketQr({ label = "Ticket QR code", value }) {
  if (!value) {
    return null;
  }

  return (
    <figure className="rrh-ticket-qr">
      <QRCodeSVG
        value={value}
        size={212}
        level="M"
        includeMargin
        title={label}
      />
      <figcaption>{label}</figcaption>
    </figure>
  );
}
